import {
  SettingsFormControl,
  SettingsGroup,
  TextInputField
} from '@sequencehq/core-components'

import { MerchantBankAccountDetails } from '../bankDetails.types'

import { BASE_INPUT_FIELD_STYLES } from 'SettingsV2/settings.constants'
import { useForm } from '@sequencehq/utils'
import { required } from '@sequencehq/utils/validation'

export const useSwedishBankgiroForm = ({
  bankDetails,
  showValidationErrors
}: {
  bankDetails?: MerchantBankAccountDetails['value']
  showValidationErrors: boolean
}) => {
  return useForm({
    value: {
      accountName: bankDetails?.swedishBankgiroDestination?.accountName ?? '',
      bankgiroNumber:
        bankDetails?.swedishBankgiroDestination?.bankgiroNumber ?? ''
    },
    showValidationErrors,
    fieldConfiguration: [
      {
        property: 'accountName',
        validation: [required]
      },
      {
        property: 'bankgiroNumber',
        validation: [required]
      }
    ]
  })
}

export const SwedishBankgiroForm = ({
  fields
}: {
  fields: ReturnType<typeof useSwedishBankgiroForm>['fields']
}) => (
  <SettingsGroup title="Account details">
    <SettingsFormControl label="Account name" htmlFor="account-name">
      <TextInputField
        {...BASE_INPUT_FIELD_STYLES}
        placeholder="Account name"
        id="account-name"
        value={fields.accountName.value}
        validationErrors={fields.accountName.validationErrors}
        onChange={e => {
          fields.accountName.onChange(e.target.value)
        }}
      />
    </SettingsFormControl>
    <SettingsFormControl label="Bankgiro number" htmlFor="bankgiro-number">
      <TextInputField
        {...BASE_INPUT_FIELD_STYLES}
        placeholder="1234-5678"
        id="bankgiro-number"
        value={fields.bankgiroNumber.value}
        validationErrors={fields.bankgiroNumber.validationErrors}
        onChange={e => {
          fields.bankgiroNumber.onChange(e.target.value)
        }}
      />
    </SettingsFormControl>
  </SettingsGroup>
)
